import React from 'react'
import { useNewTranslation } from 'hooks'
import Modal from 'particles/Modal'
import { useDispatch } from 'react-redux'
import { CampaignState, saveAdditionalPayment } from 'state/campaigns'
import { CampaignPaymentSummaryData } from 'services/api/campaigns'

export interface AdditionalFeeProps {
    uuid: string
    title: string
    amount: number
}

interface DeleteAdditionalFeeProps {
    additionalFee: AdditionalFeeProps
    campaign: CampaignState
    onClose: () => void
    paymentSummary: CampaignPaymentSummaryData
    isTemplate: boolean
}

const DeleteAdditionalFee: React.FC<DeleteAdditionalFeeProps> = ({
    campaign,
    additionalFee,
    onClose,
    paymentSummary,
    isTemplate,
}) => {
    const [t] = useNewTranslation()
    const dispatch = useDispatch()

    const handleDeletePaymentAdjustment = () => {
        const additionalFees = paymentSummary?.additional_fees ?? []
        const itemExists = additionalFees.some(item => item.uuid === additionalFee.uuid)

        if (itemExists) {
            const updatedValues = additionalFees.filter(item => item.uuid !== additionalFee.uuid)
            dispatch(
                saveAdditionalPayment({
                    campaignUuid: campaign.uuid,
                    additionalFees: updatedValues,
                    isTemplate,
                    isDelete: true,
                }),
            )
        }

        onClose()
    }

    return (
        <Modal
            title={t('modalWinodow.deleteAdditonalFeeTitle', {
                additionalTitle: additionalFee?.title ?? t('appCampaign.payoutDetails.payoutAdjustment'),
            })}
            subtext={t('modalWinodow.deleteAdditonalFeeSubtext')}
            primaryButtonProps={{
                label: t('button.delete'),
            }}
            secondaryButtonProps={{
                label: t('button.cancel'),
            }}
            size="m"
            onConfirm={handleDeletePaymentAdjustment}
            onClose={onClose}
            hasIcon={false}
        />
    )
}

export default DeleteAdditionalFee
